module.exports = __webpack_public_path__ + "img/block23.a2dfec72.png";